/* eslint-disable no-undef */
import { TaboolaVideoReel } from './taboolaVideoReel';

const props = [];

export const TaboolaVideoReelDirective = reactDirective => reactDirective(TaboolaVideoReel, props);
TaboolaVideoReelDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('taboolaVideoReel', TaboolaVideoReelDirective);
